import request from '@/utils/request'

export function fetchProductList (query) {
  return request({
    url: '/wechat/api/card_product/index',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/card/api/product.js